import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import styles from "./incomeGridDetails.module.css";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, Typography } from "@mui/material";
import { Home, ArrowLeft, X } from "react-feather";
import Helmet from "react-helmet";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../../../../components/Loader";
import Footer from "../../../../../../components/Footer";
import axios from "axios";
import PaymentFilter from "./components/PaymentFilter";
import PaymentWidgetCard from "./components/PaymentWidgetCard";
import PaymentList from "./components/PaymentList";
import AddBill from "./paymentcomps/AddBill";
import AddCredit from "./paymentcomps/AddCredit";
import RecordPayment from "./paymentcomps/RecordPayment";
import { toast } from "react-smart-toaster";
import dayjs from "dayjs";
import withCustomAuthenticationRequired from "../../../../../../auth/withCustomAuthenticationRequired";

const IncomeGridDetails = ({ history, match }) => {
  const { id } = match.params;
  const redirect = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [contentLoading2, setContentLoading2] = useState(true);
  const [rentRollData, setRentRollData] = useState(null);
  const [propertyId, setPropertyId] = useState(0);
  const [allData, setAllData] = useState([]);
  const [filterredData, setFilterredData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [apiLoading, setApiLoading] = useState(false);
  const [addBillModalShow, setAddBillModalShow] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [editId, setEditId] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [incomeCategories, setIncomeCategories] = useState([]);
  const [addCreditModalShow, setAddCreditModalShow] = useState(false);
  const [addPaymentModalShow, setAddPaymentModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [deleteType, setDeleteType] = useState("");
  const [filterData, setFilterData] = useState({ searchKey: "", payment_type: ["bill", "credit", "payment"] });
  const [dateFilterData, setDateFilterData] = useState(null);

  useEffect(() => {
    fetchRentRollData();
  }, [id]);

  const fetchRentRollData = async () => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    await axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/rent-rolls-new/" + id, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setContentLoading2(false);
      setRentRollData(response.data.data);
      if (response.data.data && response.data.data?.property_id) {
        setPropertyId(response.data.data?.property_id);
      }
    }).catch((error) => {
      setContentLoading2(false);
    });
  };

  useEffect(() => {
    const fetchIncomeCategory = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      await axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/income-categories", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setIncomeCategories(response.data.data);
      });
    };

    fetchIncomeCategory();
  }, [getAccessTokenSilently, id]);

  useEffect(() => {
    getRentRollList();
  }, [page]);

  const getRentRollList = async () => {
    if (apiLoading) return;
    setApiLoading(true);

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    setHasMore(false);

    await axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/rent-rolls/list-new", {
      params: { page: 1, rent_roll_id: id },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setContentLoading(false);
      setAllData(response.data.data);
      setHasMore(response.data.has_more);
    }).catch((error) => {
      setContentLoading(false);
    }).finally(() => {
      setApiLoading(false);
    });
  }

  useEffect(() => {
    let filterredDataTemp = [...allData];

    let balanceNew = 0;

    filterredDataTemp = filterredDataTemp.reverse().map(group => {

      let transactions = [...group.transactions].reverse();

      transactions = transactions.map(i => {

        if (i?.type === 1) {
          balanceNew += parseFloat(i?.amount || 0);
        }

        if (i?.type === 2) {
          balanceNew -= parseFloat(i?.amount || 0);
        }

        return { ...i, balance_new: balanceNew };
      });


      return { ...group, transactions: transactions.reverse() };
    }).reverse();

    if (filterData?.searchKey !== "") {
      filterredDataTemp = filterredDataTemp.map(monthGroup => ({
        ...monthGroup, transactions: monthGroup.transactions.filter(item => {
          return item.description?.toLowerCase().includes(filterData?.searchKey.toLowerCase());
        })
      })).filter(monthGroup => monthGroup.transactions.length > 0);
    }

    if (filterData?.payment_type?.indexOf("bill") === -1) {
      filterredDataTemp = filterredDataTemp.map(monthGroup => ({
        ...monthGroup, transactions: monthGroup.transactions.filter(item => {
          return item?.type !== 1;
        })
      })).filter(monthGroup => monthGroup.transactions.length > 0);
    }

    if (filterData?.payment_type?.indexOf("credit") === -1) {
      filterredDataTemp = filterredDataTemp.map(monthGroup => ({
        ...monthGroup, transactions: monthGroup.transactions.filter(item => {
          return item?.payment_type !== "add-credit";
        })
      })).filter(monthGroup => monthGroup.transactions.length > 0);
    }

    if (filterData?.payment_type?.indexOf("payment") === -1) {
      filterredDataTemp = filterredDataTemp.map(monthGroup => ({
        ...monthGroup, transactions: monthGroup.transactions.filter(item => {
          return item?.payment_type !== "record-payment" && item?.payment_type !== "online-payment";
        })
      })).filter(monthGroup => monthGroup.transactions.length > 0);
    }

    if (dateFilterData && dateFilterData !== "") {
      filterredDataTemp = filterredDataTemp.map(monthGroup => ({
        ...monthGroup, transactions: monthGroup.transactions.filter(item => {
          if (dayjs(dayjs(item.date).format("YYYY-MM-DD")).isBetween(dayjs(dateFilterData[0]).format("YYYY-MM-DD"), dayjs(dateFilterData[1]).format("YYYY-MM-DD"), undefined, [])) {
            return true;
          }
          return false;
        })
      })).filter(monthGroup => monthGroup.transactions.length > 0);
    }

    setFilterredData(filterredDataTemp);
  }, [filterData, allData, dateFilterData]);

  const addData = (data) => {
    fetchRentRollData();
    getRentRollList();
  }

  const updateData = (data) => {
    fetchRentRollData();
    getRentRollList();
  }

  const confirmDel = async () => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    setDeleteModalShow(false);
    setLoading(true);
    return axios.delete(process.env.REACT_APP_PAYMENT_API_URL + "v1/rent-rolls/" + id + "/list/" + deleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      fetchRentRollData();
      getRentRollList();

      setDeleteId(0);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (<>
    {loading && <Loader />}

    <Helmet title={"Payment Rent Roll - " + rentRollData?.property_name + " - " + rentRollData?.apt_name} />

    <div className={`${styles.mainCard}`}>
      <div className={`${styles.SMProCusRow}`}>
        <div className={`${styles.BreadcrumbHeadSec}`}>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Payments</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>Rent Roll: {rentRollData?.tenant_name}</li>
            </ol>
          </nav>
          <div className={`${styles.PageTitleSec}`}>
            <div>
              <Link className={`${styles.BackArrow}`} onClick={() => redirect.goBack()}>
                <ArrowLeft />
              </Link>
              <Typography display="inline" className={`${styles.pageTitle}`}>Rent Roll: {rentRollData?.tenant_name}</Typography>
            </div>
          </div>
        </div>

        <div className={`${styles.RentRollDetailsSec}`}>

          <PaymentFilter rentRollData={rentRollData} data={filterredData} propertyId={propertyId} setAddPaymentModalShow={setAddPaymentModalShow.bind(this)} setAddCreditModalShow={setAddCreditModalShow.bind(this)} setAddBillModalShow={setAddBillModalShow.bind(this)} setIsUpdate={setIsUpdate.bind(this)} setEditId={setEditId.bind(this)} filterData={filterData} setFilterData={setFilterData.bind(this)} dateFilterData={dateFilterData} setDateFilterData={setDateFilterData.bind(this)} />

          <PaymentWidgetCard contentLoading={contentLoading2} rentRollData={rentRollData} />

          <PaymentList contentLoading={contentLoading} data={filterredData} setPage={setPage.bind(this)} page={page} hasMore={hasMore} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setAddBillModalShow={setAddBillModalShow.bind(this)} setAddCreditModalShow={setAddCreditModalShow.bind(this)} setAddPaymentModalShow={setAddPaymentModalShow.bind(this)} setIsUpdate={setIsUpdate.bind(this)} setEditId={setEditId.bind(this)} setDeleteModalShow={setDeleteModalShow.bind(this)} setDeleteId={setDeleteId.bind(this)} setDeleteType={setDeleteType.bind(this)} rentRollData={rentRollData} onRefundSaved={() => { fetchRentRollData(); getRentRollList(); }} />

        </div>
      </div>
    </div>

    <Dialog
      fullWidth
      maxWidth="xs"
      open={addBillModalShow}
      onClose={(e) => setAddBillModalShow(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setAddBillModalShow(false)}>
          <ArrowLeft />
        </button>
        {isUpdate ? "Update Bill" : "Add Bill"}
        <button onClick={(e) => setAddBillModalShow(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent className={`${styles.RequestBodyPop}`}>
        <AddBill
          rent_roll_id={id}
          setModalShow={setAddBillModalShow.bind(this)}
          setLoading={setLoading.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          addData={addData.bind(this)}
          updateData={updateData.bind(this)}
          isUpdate={isUpdate}
          editId={editId}
          incomeCategories={incomeCategories}
        />
      </DialogContent>
    </Dialog>

    <Dialog
      fullWidth
      maxWidth="xs"
      open={addCreditModalShow}
      onClose={(e) => setAddCreditModalShow(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setAddCreditModalShow(false)}>
          <ArrowLeft />
        </button>
        {isUpdate ? "Update Credit" : "Add Credit"}
        <button onClick={(e) => setAddCreditModalShow(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent className={`${styles.RequestBodyPop}`}>
        <AddCredit
          rent_roll_id={id}
          setModalShow={setAddCreditModalShow.bind(this)}
          setLoading={setLoading.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          addData={addData.bind(this)}
          updateData={updateData.bind(this)}
          isUpdate={isUpdate}
          editId={editId}
        />
      </DialogContent>
    </Dialog>

    <Dialog
      fullWidth
      maxWidth="xs"
      open={addPaymentModalShow}
      onClose={(e) => setAddPaymentModalShow(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setAddPaymentModalShow(false)}>
          <ArrowLeft />
        </button>
        {isUpdate ? "Update Payment" : "Record Payment"}
        <button onClick={(e) => setAddPaymentModalShow(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent className={`${styles.RequestBodyPop}`}>
        <RecordPayment
          rent_roll_id={id}
          setModalShow={setAddPaymentModalShow.bind(this)}
          setLoading={setLoading.bind(this)}
          setSnackbarMsg={setSnackbarMsg.bind(this)}
          setSnackbarOpen={setSnackbarOpen.bind(this)}
          addData={addData.bind(this)}
          updateData={updateData.bind(this)}
          isUpdate={isUpdate}
          editId={editId}
        />
      </DialogContent>
    </Dialog>

    <Dialog
      open={deleteModalShow}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setDeleteModalShow(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to delete the {deleteType}?
        <button onClick={(e) => setDeleteModalShow(false)}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The {deleteType} will be removed immediately. You can't undo this action.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => confirmDel()}>Delete</Button>
        <Button onClick={(e) => setDeleteModalShow(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Footer />

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />
  </>);
}

export default withCustomAuthenticationRequired(IncomeGridDetails, {
  onRedirecting: () => <Loader />,
});